module.exports = __webpack_public_path__ + "static/media/kai_chandrabindu.06f1711e.ogg";